export const REQUESTS_REQUEST = "REQUESTS_REQUEST";
export const REQUESTS_SUCCESS = "REQUESTS_SUCCESS";
export const REQUESTS_ERROR = "REQUESTS_ERROR";

export const REQUESTS_ADD_REQUEST = "REQUESTS_ADD_REQUEST";
export const REQUESTS_ADD_SUCCESS = "REQUESTS_ADD_SUCCESS";
export const REQUESTS_ADD_ERROR = "REQUESTS_ADD_ERROR";